module.exports = __webpack_public_path__ + "img/home_icon_xiangmuzixun.b6101d92.svg";